/**
 * Per-resource roles on a ConnectionRequest aggregate. Flat — no hierarchy;
 * gating is membership-only via plain `.includes()`. Values are prefixed with
 * `connection-request:` so roles from different aggregates can be co-located
 * in a single array without ambiguity.
 */

import { z } from "zod";

export const ConnectionRequestRoleSchema = z.enum([
  "connection-request:admin",
  "connection-request:manager",
  "connection-request:requester",
  "connection-request:target",
]);

export type ConnectionRequestRole = z.infer<typeof ConnectionRequestRoleSchema>;
